import { z } from 'zod';

import {
  userGoogleLoginRequestSchema,
  userGoogleLoginResponseSchema,
  verifyGoogleLoginRequestSchema,
  verifyGoogleLoginResponseSchema,
} from '../schema/login.schema';
import { api } from '@/utils/lib/api/api.helpers';
import { AUTHENTICATION } from '../constants/apiEndpointConstants';

const login = api<
  z.infer<typeof userGoogleLoginRequestSchema>,
  z.infer<typeof userGoogleLoginResponseSchema>
>({
  path: AUTHENTICATION.LOGIN,
  method: 'GET',
  requestSchema: userGoogleLoginRequestSchema,
  responseSchema: userGoogleLoginResponseSchema,
});

const verifyLogin = api<
  z.infer<typeof verifyGoogleLoginRequestSchema>,
  z.infer<typeof verifyGoogleLoginResponseSchema>
>({
  path: AUTHENTICATION.VERIFY,
  method: 'POST',
  requestSchema: verifyGoogleLoginRequestSchema,
  responseSchema: verifyGoogleLoginResponseSchema,
});

export const AuthAPI = {
  login,
  verifyLogin,
};
